"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FocusTrap.FocusTrap;
  }
});
var _FocusTrap = require("@mui/base/FocusTrap");